<template>
  <header id="titlebar">
    <slot name="logo">
      <!--
				You can specify the name of your file as a param
					the param will work for all standard image file types
				linking to "/" is the expected behavior from a logo
					only deviate from the given router-link with good cause 
			-->
      <router-link to="/">
        <img
          :src="require('@/assets/imgs/' + appLogoFileName)"
          class="logo"
          :alt="appTitle"
          width="100"
          height="auto"
        />
      </router-link>
    </slot>
    <template v-if="showAccountWidget">
      <div class="account-widget">
        <div class="account-widget-tenant">
          {{ activeTenantLabel }}
        </div>
        <div
          class="account-widget-content"
          @click="showAccountMenu = !showAccountMenu"
          role="button"
          title="account menu"
          label="account menu"
        >
          <div class="account-name">
            {{ loggedInUserName }}
            <template v-if="showIdToken">
              <infoDialogBox title="Access Token" activatorText="">
                {{ accessToken }}
              </infoDialogBox>
            </template>
          </div>
        </div>
        <div
          class="account-menu drop-menu"
          v-show="showAccountMenu"
          @mouseleave="showAccountMenu = false"
        >
          <ul class="plain-list" role="navigation">
            <slot name="accountMenuList">
              <!--
								Use <li> items to list desired account actions as seen below
								Actions here should modify or assist in modifying:
									login status
									user or team data
									tenant or client context
								This list will always contain a standard logout; do not add your own.
									use the onLogoutExt param to add necessary logic to the logout action.
								To override locally, I suggest creating a component which contains titlebar.vue
									This will prevent having to repeat any custom menu list slotted in here.
							
								<li>
									<router-link
										to="/Account"
										class="drop-menu-option"
										title="Account"
										label="Account"
									>
										Account
									</router-link>
								</li>
							-->
            </slot>
            <li>
              <div
                @click="logout"
                class="drop-menu-option"
                title="Logout"
                label="Logout"
              >
                Logout
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "titlebar",
  data() {
    return {
      showAccountMenu: false,
    };
  },
  props: {
    appLogoFileName: {
      // The full name and file type: example1.png / example2.svg / example3.jpg
      type: String,
      required: true,
    },
    showAccountWidget: {
      /* 
					Do you want to show the logged in user's name with an account-oriented menu?
					This should likely only be hidden if the system doesn't require authentication.
				*/
      type: Boolean,
      default: true,
    },
    onLogoutExt: {
      // This runs in addition to (but before) the default cognito logout.
      type: Function,
      required: false,
    },
  },
  computed: {
    ...mapState({
      loggedInUserName: (state) => state.account.loggedInUserName,
      activeTenantLabel: (state) => state.account.activeTenantLabel,
      tenantId: (state) => state.account.tenantId,
      accessToken: (state) => state.account.loggedInUserIdToken,
    }),
    appTitle() {
      return process.env.VUE_APP_TITLE;
    },
    showIdToken() {
      let show = this.appTitle.endsWith("Local")
        ? true
        : this.appTitle.endsWith("Dev")
        ? true
        : this.appTitle.endsWith("Staging")
        ? true
        : false;
      return show;
    },
  },
  methods: {
    logout: function () {
      if (this.onLogoutExt) {
        this.onLogoutExt();
      }
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss" scoped>
#titlebar {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: space-between;
  align-items: center;
  grid-area: titlebar;
  padding: 1em $qvo-spacing-default;
}

#titlebar .account-widget {
  display: flex;
  position: relative;
  padding-right: $qvo-spacing-default;

  .account-widget-tenant {
    display: inline-block;
    color: #fff;
    padding-right: 1em;
    border-right: $qvo-border-default;
  }

  .account-widget-content {
    &:hover,
    &:active,
    &:focus {
      .account-name {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .account-name {
    display: inline-block;
    padding-left: 1em;
    color: #fff;

    &::v-deep .v-icon {
      color: #fff;
      margin-top: -0.15em;
    }
  }

  .account-menu {
    position: absolute;
    right: 2em;
    top: 2.5em;
    width: max-content;
    text-align: center;
    z-index: 99;
  }

  .drop-menu-option {
    padding: 0 2em;

    .v-icon {
      padding-left: 0.25em;
    }

    &:hover .v-icon,
    &:active .v-icon,
    &:focus .v-icon {
      color: #fff;
    }
  }
}

// Medium Screen Queries - as seen via vertical tablets or floated desktop windows
@media only screen and (min-width: 500px) {
  #titlebar {
    .account-widget {
      justify-self: right;
    }
  }
}
</style>
